import React from 'react'

const Multiminter = () => {
    return (
        <div className="container row minter-outer-div">
            <div className="col-md-4 preview-outer">
                <h4> Preview</h4>
                <div className="preview-div">
                    <form runat="server"> 
                        <img id="blah" src="#" alt="your image here" />
                    </form>  
                </div>  
            </div>



            <div className="col-md-4 mint-col-1">
                <label for="">Upload file</label> 
                <p> PNG, GIF, WEBP or MP4. Max 100mb.</p>
                <input accept="image/*" type='file' id="imgInp" />

                <label for=""> Put on sale </label>
                <input type="checkbox" />
                <p> You’ll receive bids on this item</p>
                
                <label for="name">Name</label>
                <input type="text" id="nftname" placeholder ="eg: Smith" />

                <label for="description">Description</label>
                <input type="text" id="nftdescription" placeholder="describe your NFT" />

                <label for="properties">Properties</label>
                <input type="text" id="nftproperties" placeholder="eg:size" />

                <button className="mint-btn">Create Item</button>
            </div>


            <div className="col-md-4 mint-col-2">
                <label for="roaylity">Roylity</label>
                <input type="number" placeholder="% value" />
                <label for="numofcopies"> Number of NFTs</label>
                <input id="numofcopies" type="number" placeholder="2"/>
                <label for="category">Category</label>
                <select name="categoryselect" id="nftcat">
                    <option value="exclusive">Exclusive</option>
                    <option value="art">ART</option>
                    <option value="sports">Sports</option>
                    <option value="entertainment">Entertainment</option>
                    <option value="gaming">Gaming</option>
                    <option value="collectibles">Collectibles</option>
                    <option value="esports">Esports</option>
                    <option value="nftforgood">NFT for Good </option>
                </select>
            </div>

        </div>
    )
}

export default Multiminter
